<template>
	<div :class="style.navbar">
		<div :class="style.identity">
			<span>{{ identity.name }}</span>
			<img v-if="identity.avatar" :src="identity.avatar"
				width="36" height="36"
				:class="style.avatar"
				/>
		</div>
		<ul v-if="identity.isRegistered">
			<li v-for="page in pages" :key="page.id"><a href="#" @click="switchTab(page.id)">{{ page.name }}</a></li>
		</ul>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType, useCssModule } from 'vue'
import { useIdentity } from '@/composables/useIdentity'

interface Page {
	id: string
	name: string
}

export default defineComponent({
	props: {
		pages: {
			type: Array(Object) as PropType<Page[]>,
			default: [],
		},
	},
	setup({ pages }, { emit }) {
		const identity = useIdentity()
		const switchTab = (tabName : string) => {
			$('.content').hide()
			$(`#div_${tabName}`).show()

			switch (tabName) {
				case 'order': // 若是點選"訂單查詢"tab則進行訂單查詢
					checkOrder()
					break
			}

			emit('switchTab', tabName)
		}

		return {
			style: useCssModule(),
			identity,
			switchTab,
			pages,
		}
	}
})
</script>

<style lang="scss" module>
.navbar {
	background-color: #009fcc;
	color: #ffffff;
	text-align: center;
	border-radius: 0 0 8px 8px;
	margin-bottom: 12px;

	& > *:last-child {
		border-radius: 0 0 8px 8px;
	}
}

.identity {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	text-align: center;
	padding: 14px 16px;
	text-decoration: none;
}

.navbar > ul {
	display: flex;
	list-style-type: none;
	margin: 0;
	padding: 0;
	overflow: hidden;

	& > li {
		flex-grow: 1;
		display: inline-block;
		position: relative;

		&:before {
			content: '';
			position: absolute;
			width: 2px;
			top: 8px;
			left: -1px;
			bottom: 8px;
			background: #eee;
			pointer-events: none;
		}
		&:first-child:before {
			content: initial;
		}

		& > a, & > button {
			cursor: pointer;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 14px 16px;
			text-decoration: none;

			&:hover {
				background-color: #02bef3;
				transition: background-color 250ms;
			}
		}

		& > div {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 14px 2px;
			text-decoration: none;
		}
	}
}

.avatar {
	margin: -.5em 0 -.5em 8px;
	border-radius: 4px;
	border: 1px solid #eee;
}
</style>
